<template>
  <v-layout :loading="loadingCluster">
    <div
      v-if="cluster"
      class="py-14 sm:pt-20 pb-36"
    >
      <div class="container">
        <h1 class="title-1 mb-12 text-center">
          {{ cluster.title }}
        </h1>

        <div
          class="bottom-navbar-mobile sm:rounded sm:static sm:w-auto sm:inline-block sm:mb-4 fixed left-0 z-10 w-full p-5 bg-white shadow"
        >
          <div class="flex space-x-3">
            <v-input-switch
              v-model="unreadArticlesOnly"
              :on-click="onFilterChange"
            />
            <label
              class="block text-gray-600"
              @click="unreadArticlesOnly != unreadArticlesOnly"
            >Unread articles</label>
          </div>
        </div>

        <div
          v-if="articles.length > 0"
          class="sm:grid-cols-2 md:grid-cols-3 grid gap-4"
        >
          <v-article-item
            v-for="article in orderedArticles"
            :key="article.id"
            :article="article"
            :provenance-cluster="cluster"
          />
        </div>

        <div
          v-if="articles.length == 0 && !loadingArticles"
          class="card text-center text-gray-700"
        >
          No new article at the moment, please come back later!
        </div>
      </div>
    </div>
  </v-layout>
</template>
<script>
import articleItemVue from "./article-item.vue";
export default {
  name: "v-cluster-show",
  components: {
    "v-article-item": articleItemVue
  },
  data() {
    return {
      cluster: null,
      loadingCluster: false,
      loadingArticles: false,
      articles: [],
      unreadArticlesOnly: true
    };
  },
  computed: {
    orderedArticles() {
      return _.cloneDeep(this.articles).sort((a,b) => {
        return a.read - b.read;
      });
    }
  },
  watch: {
    "$route.params.cluster" () {
      if (this.$route.params.cluster) {
        this.fetchCluster();
      }
    }
  },
  created () {
    this.fetchCluster();
  },
  methods: {
    fetchCluster () {
      this.loadingCluster = true;
      this.$http.get(this.$laravel.route("api.clusters.show", {cluster: this.$route.params.cluster}))
        .then((response) => {
          this.cluster = response.data.data;
          this.fetchArticles();
        })
        .finally(() => {
          this.loadingCluster = false;
        });
    },
    fetchArticles(params) {
      this.loadingArticles = true;
      this.$http.get(this.$laravel.route("api.articles.index", {
        cluster_id: this.$route.params.cluster,
        unread_only_active: this.unreadArticlesOnly
      }))
        .then((response) => {
          this.articles = response.data.data;
        })
        .finally(() => {
          this.loadingArticles = false;
        });
    },
    onFilterChange() {
      this.unreadArticlesOnly = !this.unreadArticlesOnly;

      this.fetchArticles();
    }
  }
};
</script>
